import { useEffect } from "react";
import type { ReactNode } from "react";
import { useLocation } from "react-router";

/** Ce composant scrolle en haut de la page à la navigation */
function ScrollToTop(): ReactNode {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
}

export default ScrollToTop;
